// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__8HHM5","itemTitle":"ClientEmergencyInfo_itemTitle__2Qwmb","itemText":"ClientEmergencyInfo_itemText__2Rqml"};